import { AttributesMixin, define, Store } from "@type-r/models";
import { AssetType } from "../../api/assetType";
import { ImportJobs } from "../../api/importJob";
import { ImportJobClose } from "../../api/importJobClose";
import { ImportJobAssetsDelete } from "../../api/importJobAssetsDelete";
import { ImportJobReprocessor } from "../../api/importJobReprocessor";
import { AssetTypeLookup, ImportJobStatusLookup } from "../../api/lookups";
import { ImortJobsFilters } from "./ImortJobsFilters";

export interface ImportJobsStore extends AttributesMixin<typeof ImportJobsStore> { }
@define
export class ImportJobsStore extends Store {
  static attributes = {
    importJobsFilter: ImortJobsFilters,
    assetTypes: AssetTypeLookup,
    importJobStatuses: ImportJobStatusLookup,
    importJobs: ImportJobs,
    importJobReprocessor: ImportJobReprocessor,
    importJobClose: ImportJobClose,
    importJobAssetsDelete: ImportJobAssetsDelete,
    selectedFilterBy: String
  }

  initialize(values?: Partial<this>, options?: any): void {
    this.importJobsFilter.assetType.set({
      selected: 0,
      options: this.assetTypes.items
        .filter(x => x.id !== AssetType.approvedLimit.toString() && x.id !== AssetType.invoiceMonetization.toString())
        .map((x) => ({
          value: x.id,
          label: x.name
        }))
    });

    this.importJobsFilter.status.set({
      selected: 0,
      options: this.importJobStatuses.items.map((x) => ({
        value: x.id,
        label: x.name
      }))
    });
  }
}  